var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAndorra(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_51)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3043 38.0155C13.9337 39.2869 16.8835 40 20 40C23.1164 40 26.0662 39.2869 28.6956 38.0155L30.4347 20L28.6956 1.98453C26.0662 0.713125 23.1164 0 20 0C16.8835 0 13.9337 0.713125 11.3043 1.98453L9.56519 20L11.3043 38.0155Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6956 38.0148C35.3855 34.7799 39.9999 27.9291 39.9999 20C39.9999 12.0709 35.3855 5.22007 28.6956 1.98523V38.0148Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3044 38.0148V1.98523C4.61445 5.22007 0 12.0708 0 20C0 27.9292 4.61445 34.7799 11.3044 38.0148Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 26.9565C19.9999 23.7651 19.9999 20.0001 19.9999 20.0001H25.2173V22.6087C25.2173 23.0619 24.3478 24.7226 22.2014 26.087C21.3885 26.6039 20.5471 26.7701 19.9999 26.9565Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7825 14.7826H19.9999V20H14.7825V14.7826Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6086 13.0435C22.6086 12.083 21.8299 11.3044 20.8695 11.3044C20.5523 11.3044 20.2559 11.3906 19.9999 11.5389C19.7439 11.3906 19.4476 11.3044 19.1304 11.3044C18.1699 11.3044 17.3913 12.083 17.3913 13.0435H13.0435V21.7391C13.0435 24.9763 15.6142 26.8484 17.6303 27.8188C17.4794 28.0765 17.3913 28.3755 17.3913 28.6957C17.3913 29.6563 18.1699 30.4349 19.1304 30.4349C19.4476 30.4349 19.744 30.3486 19.9999 30.2003C20.256 30.3486 20.5523 30.4349 20.8695 30.4349C21.8299 30.4349 22.6086 29.6563 22.6086 28.6957C22.6086 28.3755 22.5205 28.0765 22.3695 27.8188C24.3856 26.8484 26.9564 24.9763 26.9564 21.7391V13.0435H22.6086ZM24.3478 21.7391C24.3478 22.1923 24.3478 23.5713 22.2015 24.9358C21.3885 25.4527 20.5471 25.7878 19.9999 25.9741C19.4528 25.7878 18.6113 25.4527 17.7984 24.9358C15.6521 23.5713 15.6521 22.1923 15.6521 21.7391V15.6522H24.3478V21.7391Z",
    fill: "#FF9811"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_51"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndorra);
export default __webpack_public_path__ + "static/media/andorra.691101771b40db2ee7daddc759ba93cc.svg";
export { ForwardRef as ReactComponent };